import React from 'react';

const Activities = () => {
  return (
    <section id="activities" className="wrap">
  <h2 className="section-title reveal">Other working experience</h2>
      <div className="card reveal">
        <h3>Process Control Lab Assistant</h3>
        <div className="meta">ATG Hand Care(Pvt) Ltd Koggala - full time </div>
        <div className="meta">January 2020 - July 2021 (1 yr & months)</div>
        <div className="meta">Sri Lanka</div>
      </div>
      {/* Achievements removed per request */}
    </section>
  );
};

export default Activities;